import { render, staticRenderFns } from "./PreviewTile.vue?vue&type=template&id=470ce88a&"
import script from "./PreviewTile.vue?vue&type=script&lang=js&"
export * from "./PreviewTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports